function scrollListener (scrollCallBack) {
  this.lastScrollY = 0,
    this.ticking = false
  this.scrollCallback = scrollCallBack

  var _this = this

    // Detect request animation frame
  var requestAnimationFrameMethod = window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    // IE Fallback, you can even fallback to onscroll
    function (callback) { window.setTimeout(callback, 1000 / 60) }

    /**
     * Callback for our scroll event - just
     * keeps track of the last scroll value
     */
  this.onScroll = function (ev) {
    this.requestTick()
  }

    /**
     *
     *
     * Calls rAF if it's not already
     * been done already
     */
  this.requestTick = function () {
    if (!this.ticking) {
          //  console.log(_this);
      requestAnimationFrameMethod(_this.update.bind(this))
      this.ticking = true
    }
  }

    /**
     *
     * Our animation callback
     */
  this.update = function () {
    var offset = 0

    var direction

    let scrollY = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY

    if (scrollY > this.lastScrollY) {
      direction = 'down'
    } else if (scrollY < this.lastScrollY) {
      direction = 'up'
    }

    var struct = {
      'scrollPos': scrollY,
      'lastScrollPos': this.lastScrollY,
      'diff': scrollY - this.lastScrollY,
      'direction': direction
    }

    this.lastScrollY = scrollY

    if (this.scrollCallback) {
      this.scrollCallback(struct)
    }

        // allow further rAFs to be called
    this.ticking = false
  }

  this.destroy = function () {
    this.scrollCallback = undefined

        // somehow this line doesnt remove the listener... weird
    window.removeEventListener('scroll', this.scrollBinding, false)
  }

  this.scrollBinding = this.onScroll.bind(this)

    // only listen for scroll events
  window.addEventListener('scroll', this.scrollBinding, false)
}

module.exports = scrollListener



// WEBPACK FOOTER //
// ./assets/js/modules/module-scroll-handler.js